import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function AccountTreePrint(body,name) {

    let bList = []
    let balanceFooter = ['Total', 0];
        body.forEach(element => {
        const b = [
            `[${element.data.name.trim()}]`,
            printFormatNumber(element.data.balance)]
        balanceFooter[1] += sF(element.data.balance);
        bList = [...bList, b]
        if (element.children) {
            element.children.forEach(child => {
                const c = [
                    child.data.name,
                    printFormatNumber(child.data.balance),
                ]
                bList = [...bList, c]

            })
        }
    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Name', 'Balance'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Account Report", 300, 40)

    doc.text(`Date: ${ToBritishDate(new Date())}`, 500, 55)
        autoTable(doc, {
                headStyles: {fontSize: 8, halign: 'center', fillColor: [41, 128, 185]}, // Added a nice blue header
                footStyles: {fontSize: 8, halign: 'center', fillColor: [241, 241, 241]},
                bodyStyles: {fontSize: 8, cellWidth: "auto"},
                alternateRowStyles: {fillColor: [245, 245, 245]}, // Light gray for striped effect
                showFoot: "lastPage",
                head: [heading],
                startY: 70,
                theme: 'striped', // Changed from 'grid' to 'striped'
                body: bList.map(item => {
                return item.map(item =>{
                    return item.toLocaleString()
                })
            }),
            foot: [balanceFooter.map(item =>{
                return item.toLocaleString()
            })],
            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "right"}
            }
        }
    )
    doc.save(`Accounts-${ToBritishDate(new Date())}.pdf`);

}
